import { render, staticRenderFns } from "./TaxonomyCSVUpload.vue?vue&type=template&id=50fe1f20&"
import script from "./TaxonomyCSVUpload.vue?vue&type=script&lang=js&"
export * from "./TaxonomyCSVUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports